import httpService from "../httpService";

export default {
  findAllByHcCaseMasterId(hcCaseMasterId, type) {
    let params = {hcCaseMasterId: hcCaseMasterId, type: type};
    return httpService.get("/hcCaseFlightFile/findAllByHcCaseMasterId", {params: params});
  },
};



// WEBPACK FOOTER //
// ./src/services/maybay/hcCaseFlightFileService.js